<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-5 mr-auto">
        <h3>Advertiser's Affiliate Management</h3>
      </div>
      <div class="col-2 ml-auto text-right">
        <a class="btn btn-outline-default"  (click)="back()">
          <i class="fas fa-chevron-left"></i>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <label for=""><u>Filter by affiliate</u></label>
        <input type="text" class="form-control" placeholder="enter affiliate" [(ngModel)]="filterable.affiliate" />
      </div>
      <div class="col-2 d-flex align-items-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>

    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col-2 ml-auto text-right">
    <button class="btn btn-outline-success text-dark font-weight-bold" [routerLink]="['/dashboard/offer-stream/advertiser', advertiserId, 'affiliate', -1]">+ Affiliate</button>
  </div>
</div>
<table id="keywordList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>No.</th>
      <th>Affiliate</th>
      <th>Limitation</th>
      <th>URL</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="13">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="13">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let affiliate of affiliates; index as i;">
      <td>{{i + 1}}</td>
      <td>{{affiliate.affiliate}}</td>
      <td class="text-left">
        MIN: {{affiliate.min}} <br>
        MAX: {{affiliate.max}} <br>
        RATE: {{affiliate.rate}}
      </td>
      <td class="text-left">
        URL: {{affiliate.url}} <br>
        Customize URL: {{affiliate.customizedUrl}}
      </td>
      <td>
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/offer-stream/advertiser', advertiserId, 'affiliate', affiliate.id]">
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteAffiliate(affiliate)">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="13" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>
